import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material';
import { HttpService } from '../http.service';
import { SnackbarService } from '../snackbar.service';
import { ValidationService } from '../validation.service';

@Component({
  selector: 'app-registered-vehicles',
  templateUrl: './registered-vehicles.component.html',
  styleUrls: ['./registered-vehicles.component.scss']
})
export class RegisteredVehiclesComponent implements OnInit {
  @ViewChild('registerVehicleDialog', { static: true }) registerVehicleDialog: TemplateRef<any>;

  constructor(private dialog: MatDialog, private http: HttpService, private snackbar: SnackbarService, private valid: ValidationService) { }
  vehicles: any = [
    { no: 1, vehiclePlate: '123abc', seqNo: '12345', plateType: 'red', imei: '123456789', activity: 'default', refKey: '1234567', carrier: 'riyadh tyransport', actions: '' },
    { no: 2, vehiclePlate: '123abc', seqNo: '12345', plateType: 'red', imei: '123456789', activity: 'default', refKey: '1234567', carrier: 'riyadh tyransport', actions: '' },
    { no: 3, vehiclePlate: '123abc', seqNo: '12345', plateType: 'red', imei: '123456789', activity: 'default', refKey: '1234567', carrier: 'riyadh tyransport', actions: '' },
  ];
  showLoader = false;
  displayedColumns = ['no', 'vehiclePlate', 'seqNo', 'plateType', 'imei', 'activity', 'refKey', 'carrier', 'actions'];
  registerVehicleDialogRef: any;
  dataToSend: any = {};
  vehicleArr = [];
  ngOnInit() {

  }
  openupdateFreightDialog() {
    this.getVehicles();
    this.registerVehicleDialogRef = this.dialog.open(this.registerVehicleDialog);
  }
  getVehicles() {
    this.showLoader = true;

    this.http.post('vehicle/many', {}, 3).subscribe(
      (data: any) => {
        this.showLoader = false;
        const vehicles = data.data.vehicles;
        this.vehicleArr = [];
        vehicles.forEach((element) => {
          this.vehicleArr.push({
            regNo: element.REG_number,
            _id: element._id
          });
        });
        console.log(this.vehicleArr);

      },
      (err: any) => {
        this.snackbar.openSnackBar(err.error.message, '', 'err');
        if (err.error.statusCode == 401) {
          this.valid.logout();
        }
      }
    );
  }
  closeDialog() {
    this.registerVehicleDialogRef.close();
  }
  selectVehicleType(vehicle, event) {
    if (event.source._selected) {
      this.dataToSend.vehicle_id = vehicle._id;
      this.dataToSend.REG_number = vehicle.regNo;
    }
  }

}
